import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BodyContentContainer from "components/common/LayoutComponents/BodyContentContainer";
import CircularProgressWithLabel from "../CircularProgressWithLabel";
import { getContinueInnercise } from "services/program";
import { verifyResponse } from "utils/httpRequest";
import {
  StyledContinueListening,
  StyledContinueListeningContainer,
  StyledContinueListeningItem,
} from "./ContinueListening.style";

const ContinueListening = () => {
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [recommendedPrograms, setRecommendedPrograms] = useState([]);

  const getRecommendations = async () => {
    setLoading(true);
    const response = await getContinueInnercise();
    verifyResponse(response);
    setRecommendedPrograms(response.data.list);
    setLoading(false);
  };

  useEffect(() => {
    getRecommendations();
  }, []);

  return (
    <StyledContinueListening>
      <BodyContentContainer>
        <h3>Continue Listening</h3>
        <StyledContinueListeningContainer>
          {recommendedPrograms.map((program, programIndex) => {
            return (
              <StyledContinueListeningItem
                key={`recommended-program-${programIndex}`}
                onClick={() => {
                  navigate(`/innercise/${program.id}`);
                }}
              >
                <img src={program.thumbResourceDto.urlDto.imgUrl_SM} alt="" />
                <div className="title">
                  <CircularProgressWithLabel
                    value={(program.playLength / program.totalLength) * 100}
                  />
                  {program.title}
                </div>
                <div className="category">{program.categoryName}</div>
              </StyledContinueListeningItem>
            );
          })}
        </StyledContinueListeningContainer>
      </BodyContentContainer>
    </StyledContinueListening>
  );
};

export default ContinueListening;
